export default {
  rev: {},
  challenge: {},
}
